import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import AppContext from "../../AppContext";
import TrialUpgrade from "../../components/TrialUpgrade";
import useJournals from "../../hooks/useJournals";
import { Overlay } from "../../components";
import SuccessArtWork from "../../assets/workExchange/success-artwork.png";
import { ReactComponent as DownloadSvg } from "../../assets/workExchange/download.svg";
import { ReactComponent as CopySvg } from "../../assets/icons/copy.svg";
import { langComponent } from "../../constants";
import { addDays, format } from "date-fns";
import { formatNumber } from "../../helpers/common.helper";

const PaymentCompletePage = () => {
  const { isAuth, getLang } = useContext(AppContext);
  const navigate = useNavigate();
  const { queryJournals, getChargeJournal } = useJournals();
  const [searchParam] = useSearchParams();
  const [journal, setJournal] = useState(undefined);
  const TranslationSuccess = getLang(langComponent.chat);
  const TranslationWorkExchange = getLang(langComponent.workExchange);

  if (!isAuth) {
    navigate("/");
    return;
  }

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    const id = searchParam.get("journal");
    if (!id) return;

    const { data } = await queryJournals({ _id: id }, 1, 1);

    if (!data || data.length === 0) return;

    if (data[0].status !== 2) {
      // * Get charge
      const _charge = await getChargeJournal(data[0]._id);

      if (_charge.status !== "successfull") {
        _navigateToRelevantProject(data[0].details[0]);
        return;
      }
    }

    setJournal(data[0]);
  };

  const _navigateToRelevantProject = (detail) => {
    if (detail.tendering) {
      // * Navigate to Tendering page
      navigate(`/tenderings/${detail.tendering.tendering}`);
      return;
    }

    alert("Internal error");
    navigate("/");
  };

  const handleClose = () => {
    const detail = journal.details[0];
    _navigateToRelevantProject(detail);
  };

  if (!journal) {
    return <></>;
  }

  const { _id, createdOn, grandTotal } = journal;

  return (
    <Overlay
      onClose={handleClose}
      style={{
        alignItems: "center",
        pointerEvents: "none",
      }}
    >
      <div className="success-payment-container">
        <div className="success-payment-container-content">
          <div className="success-payment-container-content-image">
            <img src={SuccessArtWork} />
            <div className="success-payment-container-content-image__text">
              {TranslationWorkExchange("Success")}
            </div>
          </div>

          <div className="success-payment-container-content-detail">
            <div className="success-payment-container-content-detail__start">
              {TranslationWorkExchange("Transaction ID")}
            </div>
            <div className="success-payment-container-content-detail__end">
              {_id} <CopySvg onClick={() => handleCopy(_id)} />
            </div>
            <div className="success-payment-container-content-detail__start">
              {TranslationWorkExchange("Date")}
            </div>
            <div className="success-payment-container-content-detail__end">
              {format(addDays(new Date(createdOn), 0), "dd/MM/yyyy")}
            </div>
            {/* {cardDetails?.cardNo && (
              <>
                <div className="success-payment-container-content-detail__start">
                  {TranslationWorkExchange("Type payment")}
                </div>
                <div className="success-payment-container-content-detail__end">
                  {TranslationSuccess("Credit card")}{" "}
                  {cardDetails.cardNo.substring(cardDetails.cardNo.length - 3)}
                </div>
              </>
            )} */}
            <div className="success-payment-container-content-detail__start">
              {TranslationSuccess("Price")}
            </div>
            <div className="success-payment-container-content-detail__end">
              {formatNumber(grandTotal, "THB")}
            </div>
          </div>
          <div className="success-payment-container-content-footer">
            {/* <div
              className={`success-payment-container-content-footer__download`}
              onClick={handleDownload}
            >
              <DownloadSvg /> {TranslationWorkExchange("Download")}
            </div> */}
            <div
              className="success-payment-container-content-footer__btn"
              onClick={handleClose}
            >
              {TranslationWorkExchange("Done")}
            </div>
          </div>
        </div>
      </div>
    </Overlay>
  );
};

PaymentCompletePage.propTypes = {};

export default PaymentCompletePage;
